/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OperatorActivityDetailedReportModel { 
    lastname?: string;
    firstname?: string;
    patronymic?: string;
    asteriskId?: string;
    onlineTime?: number;
    offlineTime?: number;
    isOnline?: boolean;
    lastOnlineTime?: string;
    online?: boolean;
}

